import { api } from "./api";

const categoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query({
      query: () => "category",
      providesTags: ["category"],
    }),
    addCategory: builder.mutation({
      query: (newCategory) => ({
        url: "category",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["category"],
    }),
    removeCategory: builder.mutation({
      query: (id) => ({
        url: `category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["category"],
    }),
    editCategory: builder.mutation({
      query: ({id,...editData}) => ({
        url: `/category/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["category"],
    }),
  }),
});

export const {
  useGetCategoryQuery,
  useAddCategoryMutation,
  useRemoveCategoryMutation,
  useEditCategoryMutation,
} = categoryApi;
